module.exports = __webpack_public_path__ + "static/img/Export.28e3ff81.svg";